// Import all modules
// _______________________________________________
import breakpoint from "../utilities/breakpoint";

import closeFlashMessage from "../modules/close-flash-message";
import donutWorkoutChart from "../modules/profile-donut-workout-chart";
import formCollapsedGroup from "../modules/form-collapsed-group";
import formCustomSelect from "../modules/form-custom-select";
import formScrollToBackendError from "../modules/form-scroll-to-backend-error";
import formValidation from "../modules/form-validations";
import graphWorkoutChart from "../modules/profile-graph-workout-chart";
import tableFeeHistory from "../modules/profile-table-fee-history";
import tablePurchaseHistory from "../modules/profile-table-purchase-history";
import initialAriaFocus from "../modules/link-anchor-aria-focus";
import menuMobile from "../modules/menu-mobile";
import profileMenuDropdown from "../modules/profile-menu-dropdown";
import menuMobileLogin from "../modules/menu-mobile-login";
import notifications from "../modules/notifications";
import optInPopup from "../modules/opt-in-popup";
import optInPopupBirthday from "../modules/opt-in-popup-birthday";
import updatedHomeClubPopup from "../modules/updated-home-club-popup";

// Controller Generation
import { controller } from "../utilities/savnac";

// Create Controllers
// _______________________________________________
const universal = controller(
  {
    //
  },
  {
    breakpoint,
    closeFlashMessage,
    initialAriaFocus,
    notifications,
  }
);

const sessions_new = controller({
  menuMobileLogin,
  formValidation,
  formScrollToBackendError,
});

const sessions_create = controller({
  formValidation,
  formScrollToBackendError,
});

const registrations_new = controller({
  menuMobileLogin,
  formValidation,
  formCustomSelect,
  formScrollToBackendError,
});

const registrations_create = controller({
  formValidation,
  formCustomSelect,
  formScrollToBackendError,
});

const registrations_edit = controller({
  formValidation,
  formCustomSelect,
  formScrollToBackendError,
  optInPopupBirthday,
});

const registrations_update = controller({
  formValidation,
  formCustomSelect,
  formScrollToBackendError,
  optInPopupBirthday,
});

const registrations_validate_club = controller({
  menuMobile,
  formValidation,
  formCustomSelect,
  formScrollToBackendError,
  profileMenuDropdown,
});

const passwords_new = controller({
  formValidation,
  formScrollToBackendError,
});

const passwords_create = controller({
  formValidation,
  formScrollToBackendError,
});

const passwords_edit = controller({
  formValidation,
  formScrollToBackendError,
});

const passwords_update = controller({
  formValidation,
  formScrollToBackendError,
});

const my_classes_index = controller({
  menuMobile,
  profileMenuDropdown,
});

const members_index = controller({
  menuMobile,
  profileMenuDropdown,
  formCustomSelect,
  donutWorkoutChart,
  graphWorkoutChart,
  tableFeeHistory,
  tablePurchaseHistory,
  optInPopup,
  updatedHomeClubPopup,
});

const payment_edit = controller({
  formValidation,
  formCustomSelect,
  formCollapsedGroup,
  formScrollToBackendError,
});

const payment_update = controller({
  formValidation,
  formCustomSelect,
  formCollapsedGroup,
  formScrollToBackendError,
});

const payment_new = controller({
  formValidation,
  formCustomSelect,
  formCollapsedGroup,
  formScrollToBackendError,
});

const payment_create = controller({
  formValidation,
  formCustomSelect,
  formCollapsedGroup,
  formScrollToBackendError,
});

const reactApp =  controller({
  profileMenuDropdown
})
const members_account_management_app = reactApp;
const booking_index = reactApp;
const membership_cancellation_show = reactApp;

const sams_club_new = controller({
  menuMobile,
  profileMenuDropdown,
});

// Export Controllers
// _______________________________________________
export {
  universal,
  sessions_new,
  sessions_create,
  registrations_new,
  registrations_create,
  registrations_edit,
  registrations_update,
  registrations_validate_club,
  passwords_new,
  passwords_create,
  passwords_edit,
  passwords_update,
  my_classes_index,
  payment_edit,
  payment_update,
  payment_new,
  payment_create,
  members_index,
  members_account_management_app,
  booking_index,
  membership_cancellation_show,
  sams_club_new
};
